<template>
  <SmallSpinner v-if="disableComponent" :color="defaultColor" />
  <v-menu
    v-else
    offset-y
    bottom
    auto
    :close-on-content-click="true"
    min-width="5"
  >
    <template v-slot:activator="{ on, attrs }">
      <PatientRiskColorIndicators
        v-bind="{ ...attrs, patientRisks: selectedPatientRisks }"
        v-on="on"
      />
    </template>

    <PatientRiskSelect
      v-model="selectedPatientRisksIndices"
      :patientRisks="patientRisks"
      @input="submitPatientRisks"
    />
  </v-menu>
</template>

<script>
import GET_PATIENT_RISKS from "@/graphql/patient_risks.gql";
import UPDATE_PATIENT_RISKS from "@/graphql/update_patient_risks.gql";
import ON_ATTENDANCE_PATIENT_RISKS_UPDATED from "@/graphql/subscriptions/attendance/patient_risks_updated.gql";

import SmallSpinner from "@/components/ui/load_status/small_spinner.vue";
import PatientRiskColorIndicators from "@/components/queues/attendance/patient_risk/indicators.vue";
import PatientRiskSelect from "@/components/queues/attendance/patient_risk/select.vue";

import { buildSubscription } from "@/components/graphql/subscriptions.js";

export default {
  name: "PatientRisk",
  components: {
    SmallSpinner,
    PatientRiskSelect,
    PatientRiskColorIndicators,
  },
  props: {
    attendance: Object,
    attendanceEsigned: Boolean,
    defaultColor: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedPatientRisksIndices: [],
      subscriptionLoaded: false,
    };
  },
  apollo: {
    patientRisks: {
      query: GET_PATIENT_RISKS,
      result() {
        const indices = this.findSelectedPatientRisksIndices(
          this.attendance.patientRisks
        );

        this.selectedPatientRisksIndices = indices;
      },
    },
    $subscribe: {
      attendancePatientRisksUpdated() {
        return buildSubscription({
          query: ON_ATTENDANCE_PATIENT_RISKS_UPDATED,
          variables: {
            attendanceId: this.attendance.id,
          },
          onSuccess: ({ attendancePatientRisksUpdated: { patientRisks } }) => {
            this.updateSelectedPatientRisks(patientRisks);
          },
          onSubscriptionLoadStatusUpdate: (value) => {
            this.subscriptionLoaded = value;
          },
          errorNotificationMessage:
            "Ocorreu um erro ao tentar atualizar os riscos do paciente.\n" +
            "Você não está recebendo mais atualizações, recarregue a página para atualizar.",
        });
      },
    },
  },
  computed: {
    disableComponent() {
      return (
        this.isQueryLoading ||
        this.isActionCableClosed ||
        !this.subscriptionLoaded
      );
    },
    isQueryLoading() {
      return this.$apollo.queries.patientRisks.loading;
    },
    isActionCableClosed() {
      return !this.$store.state.actionCable.isOpen;
    },
    selectedPatientRisks() {
      return this.selectedPatientRisksIndices.map((index) => {
        return this.patientRisks[index];
      });
    },
  },
  methods: {
    findSelectedPatientRisksIndices(attendancePatientRisks) {
      return attendancePatientRisks.map((attendancePatientRisk) => {
        return this.patientRisks.findIndex(
          (patientRisk) => patientRisk.id === attendancePatientRisk.id
        );
      });
    },
    async updateAttendancePatientRisks() {
      if (this.attendanceEsigned) return;

      const patientRiskIds = this.selectedPatientRisks.map((r) => r.id);

      await this.apolloMutate({
        mutation: UPDATE_PATIENT_RISKS,
        variables: {
          attendanceId: this.attendance.id,
          patientRiskIds,
        },
      });
    },
    async submitPatientRisks() {
      await this.updateAttendancePatientRisks();
    },
    updateSelectedPatientRisks(newPatientRisks) {
      const newIndices = this.findSelectedPatientRisksIndices(newPatientRisks);

      this.selectedPatientRisksIndices = newIndices;
    },
  },
};
</script>

<style lang="scss" scoped></style>
